import { createSlice } from '@reduxjs/toolkit';

export const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    id: null,
    firstName: null,
    lastName: null,
    address: null,
    introduction: null
  },
  reducers: {
    setProfile: (state, action) => {
      const { id, firstName, lastName, introduction, address } = action.payload;
      state.id = id;
      state.firstName = firstName;
      state.lastName = lastName;
      state.introduction = introduction;

      if (!address) {
        return;
      }

      const {
        street,
        locality,
        region,
        country,
        postalCode,
        formatted,
        lat,
        lng
      } = address;

      state.address = {
        street,
        locality,
        region,
        country,
        postalCode,
        formatted,
        lat,
        lng
      };
    }
  }
});

export const { setProfile } = profileSlice.actions;
export default profileSlice.reducer;
